import { set } from '@ember/object';

type EventToHandle = Event & { target: HTMLInputElement };

export default function handleBinaryChange<T extends object>(context: T, name: keyof T): (evt: EventToHandle) => void {
    return (evt: EventToHandle): void => {
        set(context, name, !!evt.target.checked as any);
    };
}
